import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';

// components

export class UberNav extends Component  {
  componentDidMount() {
  }

  render() {
    const ubernav = this.props.navlist;
    const baseUrl = 'https://www.usa.edu/';


    // Submitted, training complete, failed
    if (ubernav === 'academics')
      return (
        <>
          <div className={ ubernav + '-uber subnav' } >
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <a className="highlighted" href={ baseUrl + 'degree-programs/' }>
                    <strong>DEGREE PROGRAMS</strong> ― Click here to browse all of our degree programs
                  </a>
                </div>

                <div className="col-6">
                  <ul>
                    <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/' } className="navTitle">College of Rehabilitative Sciences</a></li>
                    <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/occupational-therapy/' }>Occupational Therapy Programs</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/master-occupational-therapy-mot/' } className="third">Master of Occupational Therapy (MOT)</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/doctor-occupational-therapy/' } className="third">Doctor of Occupational Therapy (OTD)</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/post-professional-doctor-occupational-therapy-pp-otd/' } className="third">Post-Professional Doctor of Occupational Therapy (PPOTD)</a></li>
                    <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/physical-therapy-programs/' }>Physical Therapy Programs</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/doctor-physical-therapy/' } className="third">Doctor of Physical Therapy (DPT)</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/transitional-doctor-physical-therapy-tdpt/' } className="third">Transitional Doctor of Physical Therapy (tDPT)</a></li>
                    <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/master-science-speech-language-pathology-ms-slp/' }>Master of Science in Speech-Language Pathology (MS-SLP)</a></li>
                  </ul>
                </div>

                <div className="col-6">
                  <ul>
                    <li><a href={ baseUrl + 'college-health-sciences/' } className="navTitle">College of Health Sciences</a></li>
                    <li><a href={ baseUrl + 'college-health-sciences/master-health-administration/' }>Master of Health Administration (MHA)</a></li>
                    <li><a href={ baseUrl + 'college-health-sciences/master-health-science-mhs/' }>Master of Health Science (MHS)</a></li>
                    <li><a href={ baseUrl + 'college-health-sciences/doctor-of-education-edd/' }>Doctor of Education (EdD)</a></li>
                    <li><a href={ baseUrl + 'college-health-sciences/school-of-nursing/' }>School of Nursing</a></li>
                      {/* <li><a href={ baseUrl + 'college-health-sciences/school-of-nursing/master-science-nursing-msn/' } className="third">Master of Science in Nursing (MSN)</a></li> */}
                      {/* <li><a href={ baseUrl + 'college-health-sciences/school-of-nursing/doctor-of-nursing-practice-dnp/' } className="third">Doctor of Nursing Practice (DNP)</a></li> */}
                      {/* <li><a href={ baseUrl + 'college-health-sciences/school-of-nursing/post-graduate-nursing-certificates-2/' } className="third">Post-Graduate Nursing Certificates</a></li> */}
                    <li><a href={ baseUrl + 'continuing-professional-education-cpe/' } className="navTitle">Continuing Professional Education (CPE)</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/clinical-orthopaedic-residency/' }>Clinical Orthopaedic Residency</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/orthopaedic-manual-physical-therapy-fellowship/' }>Orthopaedic Manual Physical Therapy Fellowship</a></li>
                      <li><a href={ baseUrl + 'college-of-rehabilitative-sciences/physical-therapy-online-courses-international-students/' }>Physical Therapy Online Courses for International Students</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      );

    if (ubernav === 'admissions-aid')
      return (
        <>
          <div className={ ubernav + '-uber subnav' } >
            <div className="container">
              <div className="row">
                <div className="col-3">
                  <h3>Admission &amp; Aid</h3>
                  <p>USAHS focuses on providing the best and more appropriate academic and financial aid counseling throughout the admissions process. Whether applying to a first-professional, campus based program or a post-professional distance program, an assigned Enrollment Advisor is available to assist you from application to acceptance.</p>
                  <a href={ baseUrl + 'admissions-aid/' } className="button">Admission &amp; Aid Home</a>
                </div>


                <div className="col-8 col-offset-1">
                  <ul>
                    <li><a href={ baseUrl + 'admissions-aid/application-deadlines/' }>Application Deadlines | USAHS</a></li>
                    <li><a href={ baseUrl + 'admissions-aid/catalog-student-handbook/' }>Catalog/Handbook</a></li>
                    <li><a href={ baseUrl + 'admissions-aid/admissions-faqs/' }>Admissions FAQs</a></li>
                    <li><a href={ baseUrl + 'admissions-aid/financial-aid/' }>Financial Aid</a></li>
                    <li><a href={ baseUrl + 'admissions-aid/academic-calendar/' }>Academic Calendar</a></li>
                    <li><a href={ baseUrl + 'blog/coronavirus-updates/' }>COVID-19 Information</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      );

    if (ubernav === 'about')
      return (
        <>
          <div className={ ubernav + '-uber subnav' } >
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <ul>
                    <li><a href={ baseUrl + 'about/' } className="navTitle">General</a></li>
                    <li><a href={ baseUrl + 'about/history-of-university-of-st-augustine-for-health-sciences/' }>History</a></li>
                    <li><a href={ baseUrl + 'about/accreditation/' }>Accreditation</a></li>
                    <li><a href={ baseUrl + 'about/b-corp-certified/' }>B Corp Certified</a></li>
                    <li><a href={ baseUrl + 'about/student-achievement-data/' }>Student Achievement Data</a></li>
                    <li><a href={ baseUrl + 'about/institutional-learning-outcomes-ilos/' }>Institutional Learning Outcomes (ILOs)</a></li>
                    <li><a href={ baseUrl + 'blog/category/news/' }>News</a></li>
                    <li><a href={ baseUrl + 'partnerships/' }>Partnerships</a></li>
                  </ul>
                </div>

                <div className="col-4">
                  <ul>
                    <li><a href={ baseUrl + 'university-faculty/' } className="navTitle">People</a></li>
                    <li><a href={ baseUrl + 'university-administration/' }>Leadership</a></li>
                    <li><a href={ baseUrl + 'about/board-of-directors/' }>Board of Directors</a></li>
                    <li><a href="https://careers.usa.edu/">Careers</a></li>
                    <li><a href={ baseUrl + 'student-ambassador-program/' }>Student Ambassador Program</a></li>
                    <li><a href={ baseUrl + 'about/alumni/' }>Alumni</a></li>
                    <li><a href={ baseUrl + 'university-faculty/' }>Our Faculty</a></li>
                    <li><a href={ baseUrl + 'about/contact-us/' }>Contact Us</a></li>
                  </ul>
                </div>

                <div className="col-4">
                  <ul>
                    <li><a href={ baseUrl + 'about/our-campuses/' } className="navTitle">Campuses</a></li>
                    <li><a href={ baseUrl + 'about/our-campuses/san-marcos-ca/' }>San Marcos, CA</a></li>
                    <li><a href={ baseUrl + 'about/our-campuses/st-augustine-fl/' }>St. Augustine, FL</a></li>
                    <li><a href={ baseUrl + 'about/our-campuses/about-our-campuses-miami-fl/' }>Miami, FL</a></li>
                    <li><a href={ baseUrl + 'about/our-campuses/austin-tx/' }>Austin, TX</a></li>
                    <li><a href={ baseUrl + 'about/our-campuses/about-our-campuses-dallas-tx/' }>Dallas, TX</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      );
  }
}

export default UberNav;